// extracted by mini-css-extract-plugin
export var suptitle = "styles-module--suptitle--4f513";